import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"

interface Props {
  active: boolean
}

export const Trigger = styled.span`
  ${({theme}) => css`
    top: ${theme.spacing.two};
    right: ${theme.spacing.two};
  `}
  position: absolute;
`

export const ActiveCard = styled(Card)<Props>`
  height: 100%;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: ${({theme}) => theme.spacing.two};

  ${({active, theme}) => {
    if (active) {
      return `border: 2px solid ${theme.colors.success};`
    } else {
      return "border: 2px solid transparent;"
    }
  }}

  & > :last-child {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: ${({theme}) => theme.spacing.one};
  }
`

export const WalletPointsCard = styled.div`
  height: 100%;
  padding-bottom: 6px; /* this is to keep the box-shadow of the card visible */
`
